import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { tap } from 'rxjs';
import { environment } from '../environments/environment';

export let APP_CONFIG: AppConfig;

// Match the src/assets/config/config.json file
export class AppConfig {
    public readonly version: string;
    public readonly apiBaseUrl: string;
    public readonly inactivityTimeoutMinutes: number;

    public constructor(version: string, apiBaseUrl: string, inactivityTimeoutMinutes: number) {
        this.version = version;
        this.apiBaseUrl = apiBaseUrl;
        this.inactivityTimeoutMinutes = inactivityTimeoutMinutes;
    }
}

export const initializeTranslateService = (translateService: TranslateService) => {
    return () => translateService.use('en-US');
};

export const createTranslateLoader = (httpBackend: HttpBackend) => {
    const httpClient = new HttpClient(httpBackend);
    return new TranslateHttpLoader(httpClient, 'assets/i18n/', '.json');
};

export const loadConfig = (httpBackend: HttpBackend) => {
    const httpClient = new HttpClient(httpBackend);
    return () =>
        httpClient.get(`/${environment.configFile}`).pipe(
            tap((data) => {
                const typedData = data as { version: string; apiBaseUrl: string; inactivityTimeoutMinutes: number };
                APP_CONFIG = new AppConfig(
                    typedData.version,
                    typedData.apiBaseUrl,
                    typedData.inactivityTimeoutMinutes ?? 20
                );
            })
        );
};
